import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataPribadiForm from '../components/jamaah/DataPribadiForm';
import KontakDaruratForm from '../components/jamaah/KontakDaruratForm';
import StatusKesehatanForm from '../components/jamaah/StatusKesehatanForm';
import MultiStepForm, { FormStep } from '../components/common/MultiStepForm';
import { createJamaah } from '../services/jamaahService';
import {
    validateRequired,
    validateNIK,
    validateEmail,
    validatePhoneNumber,
    validateName,
    validateBirthDate,
    validateAddress
} from '../utils/validators';

const pageStyles = {
    container: {
        padding: '20px',
        maxWidth: '800px',
        margin: '0 auto',
    },
    header: {
        marginBottom: '20px',
    },
    title: {
        fontSize: '1.8rem',
        color: '#333',
        marginBottom: '5px',
    },
    subtitle: {
        fontSize: '1rem',
        color: '#666',
        marginTop: '0',
    },
    notification: {
        padding: '12px 16px',
        margin: '20px 0',
        borderRadius: '4px',
        backgroundColor: '#f8d7da',
        color: '#721c24',
        border: '1px solid #f5c6cb',
    }
};

function TambahJamaahPage() {
    const navigate = useNavigate();
    const [submitError, setSubmitError] = useState(null);

    // Validasi untuk data pribadi
    const validateDataPribadi = (formData) => {
        const errors = {};

        // Validasi field wajib
        const namaError = validateName(formData.nama_lengkap);
        if (namaError) errors.nama_lengkap = namaError;

        const nikError = validateNIK(formData.nik);
        if (nikError) errors.nik = nikError;

        const tempatLahirError = validateRequired(formData.tempat_lahir, 'Tempat lahir');
        if (tempatLahirError) errors.tempat_lahir = tempatLahirError;

        const tanggalLahirError = validateBirthDate(formData.tanggal_lahir);
        if (tanggalLahirError) errors.tanggal_lahir = tanggalLahirError;

        const alamatError = validateAddress(formData.alamat_lengkap);
        if (alamatError) errors.alamat_lengkap = alamatError;

        const emailError = validateEmail(formData.email);
        if (emailError) errors.email = emailError;

        const phoneError = validatePhoneNumber(formData.nomor_telepon);
        if (phoneError) errors.nomor_telepon = phoneError;

        return errors;
    };

    // Validasi untuk kontak darurat
    const validateKontakDarurat = (formData) => {
        const errors = {};

        // Validasi kontak darurat
        if (formData.kontak_darurat) {
            const { nama, hubungan, nomor_telepon } = formData.kontak_darurat || {};
            
            const namaError = validateRequired(nama, 'Nama kontak darurat');
            if (namaError) errors['kontak_darurat.nama'] = namaError;
            
            const hubunganError = validateRequired(hubungan, 'Hubungan kontak darurat');
            if (hubunganError) errors['kontak_darurat.hubungan'] = hubunganError;
            
            const phoneError = validatePhoneNumber(nomor_telepon);
            if (phoneError) errors['kontak_darurat.nomor_telepon'] = phoneError;
        }

        return errors;
    };

    // Validasi untuk status kesehatan
    const validateStatusKesehatan = (formData) => {
        const errors = {};
        // Validasi opsional, karena semua field di status kesehatan bisa kosong

        return errors;
    };

    // Handler untuk submit form
    const handleSubmit = async (formData) => {
        try {
            setSubmitError(null);
            console.log("Mengirim data formulir ke API:", formData);
            
            // Kirim data ke API
            const createdJamaah = await createJamaah(formData);
            console.log("Data berhasil disimpan:", createdJamaah);
            
            // Redirect ke halaman daftar jamaah setelah berhasil
            navigate('/jamaah', { 
                state: { 
                    notification: {
                        type: 'success',
                        message: 'Data jamaah berhasil disimpan' 
                    }
                }
            });
        } catch (error) {
            console.error("Error saat menyimpan data:", error);
            setSubmitError(error.message || "Terjadi kesalahan saat menyimpan data. Silakan coba lagi.");
            // Return false agar form tidak berpindah ke langkah berikutnya
            return false;
        }
    };

    return (
        <div style={pageStyles.container}>
            <div style={pageStyles.header}>
                <h1 style={pageStyles.title}>Tambah Data Jamaah Baru</h1>
                <p style={pageStyles.subtitle}>Silakan isi informasi jamaah pada formulir berikut</p>
            </div>

            {submitError && (
                <div style={pageStyles.notification}>
                    {submitError}
                </div>
            )}

            <MultiStepForm
                initialValues={{
                    // Data pribadi
                    nama_lengkap: '',
                    nik: '',
                    tempat_lahir: '',
                    tanggal_lahir: '',
                    jenis_kelamin: 'Laki-laki',
                    alamat_lengkap: '',
                    nomor_telepon: '',
                    email: '',
                    kewarganegaraan: 'Indonesia',
                    
                    // Kontak darurat
                    kontak_darurat: {
                        nama: '',
                        hubungan: '',
                        nomor_telepon: '',
                        alamat: ''
                    },
                    
                    // Status kesehatan
                    status_kesehatan: {
                        golongan_darah: '',
                        riwayat_penyakit: '',
                        alergi: '',
                        obat_rutin: ''
                    }
                }}
                onSubmit={handleSubmit}
            >
                <FormStep
                    id="data-pribadi"
                    title="Data Pribadi"
                    onValidate={validateDataPribadi}
                >
                    <DataPribadiForm />
                </FormStep>
                
                <FormStep
                    id="kontak-darurat"
                    title="Kontak Darurat"
                    onValidate={validateKontakDarurat}
                >
                    <KontakDaruratForm />
                </FormStep>
                
                <FormStep
                    id="status-kesehatan"
                    title="Status Kesehatan"
                    onValidate={validateStatusKesehatan}
                >
                    <StatusKesehatanForm />
                </FormStep>
            </MultiStepForm>
        </div>
    );
}

export default TambahJamaahPage;